/** Inter / system-ui advance width as a fraction of font size (measured at 22px). */
const INTER_WIDTH_EM: Partial<Record<string, number>> = {
  " ": 0.248,
  "\u202F": 0.124,
  "!": 0.289,
  '"': 0.357,
  "'": 0.192,
  "(": 0.333,
  ")": 0.333,
  ",": 0.248,
  "-": 0.333,
  ".": 0.248,
  "/": 0.278,
  ":": 0.248,
  ";": 0.248,
  "?": 0.456,
  "«": 0.389,
  "»": 0.389,
  "…": 0.667,
  i: 0.248,
  j: 0.222,
  l: 0.248,
  f: 0.278,
  t: 0.278,
  r: 0.333,
  m: 0.778,
  w: 0.722,
  M: 0.778,
  W: 0.944,
};

const LOWER_EM = 0.456;
const UPPER_EM = 0.556;
const DIGIT_EM = 0.556;
const DEFAULT_EM = 0.515;

function charWidthEm(char: string): number {
  const fixed = INTER_WIDTH_EM[char];
  if (fixed !== undefined) {
    return fixed;
  }
  const code = char.codePointAt(0) ?? 0;
  if (code >= 0x30 && code <= 0x39) {
    return DIGIT_EM;
  }
  if (code >= 0x61 && code <= 0x7a) {
    return LOWER_EM;
  }
  if (code >= 0x41 && code <= 0x5a) {
    return UPPER_EM;
  }
  if (code >= 0xc0 && code <= 0x24f) {
    return LOWER_EM;
  }
  return DEFAULT_EM;
}

export function measureBubbleTextWidth(text: string, fontSize: number): number {
  let width = 0;
  for (const char of text) {
    width += charWidthEm(char) * fontSize;
  }
  return width;
}

/** French typography: keep ? ! ; : and » on the same line as the preceding word. */
export function bindTrailingPunctuation(text: string): string {
  return text.replace(/ ([?!;:»])/g, "\u202F$1");
}

/** Split on regular spaces only; narrow no-break spaces stay attached. */
export function captionTokens(text: string): string[] {
  const tokens: string[] = [];
  for (const word of text.trim().split(/ +/).filter((part) => part.length > 0)) {
    tokens.push(word);
  }
  return tokens;
}
